import { render, staticRenderFns } from "./EConfiguracoesVariaveis.vue?vue&type=template&id=0853a49c"
import script from "./EConfiguracoesVariaveis.vue?vue&type=script&lang=js"
export * from "./EConfiguracoesVariaveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports